// src/data/quotes.js

const QUOTES = [
  // 🌙 Quranic Verses & Hadiths
  {
    text: 'The believers are nothing else than brothers. So make reconciliation between your brothers, and fear Allah, that you may receive mercy.',
    source: 'Surah Al-Hujurat (49:10)',
    theme: 'Brotherhood',
  },
  {
    text: 'The most beloved deed to Allah is the most regular and constant one, even if it is little.',
    source: 'Hadith (Muslim)',
    theme: 'Consistency',
  },
  {
    text: 'When a servant turns to Allah, Allah takes charge of all his needs.',
    source: 'Hadith Qudsi',
    theme: 'Reliance on God',
  },
  {
    text: 'Indeed, with hardship [will be] ease. Indeed, with hardship [will be] ease.',
    source: 'Surah Al-Inshirah (94:5-6)',
    theme: 'Patience & Ease',
  },
  {
    text: "The best among you are those who learn the Qur'an and teach it.",
    source: 'Hadith (Bukhari)',
    theme: 'Knowledge',
  },
  {
    text: 'Whoever relieves a Muslim of a distressful difficulty, Allah will relieve him of a distressful difficulty on the Day of Resurrection.',
    source: 'Hadith (Muslim)',
    theme: 'Charity & Relief',
  },

  // 📜 Said Nursi (Risale-i Nur Collection)
  {
    text: 'Faith transforms anxiety and pain into serenity and joy; disbelief turns even pleasures into torment.',
    source: 'Said Nursi',
    theme: 'Faith & Peace',
  },
  {
    text: 'True happiness is found in servitude to Allah, not in rebellion against Him.',
    source: 'Said Nursi',
    theme: 'Happiness & Servitude',
  },
  {
    text: 'A sincere prayer can change the course of destiny, for it connects the helpless servant to the Infinite Power.',
    source: 'Said Nursi',
    theme: 'Prayer & Destiny',
  },
  {
    text: 'Knowledge that does not lead to the recognition of Allah is ignorance in disguise.',
    source: 'Said Nursi',
    theme: 'Knowledge & Awareness',
  },

  // 💎 Fethullah Gülen (Pırlanta / Emeralds of the Heart)
  {
    text: 'The heart that is enlightened with faith and polished with remembrance of Allah reflects the beauty of truth to the world.',
    source: 'M. Fethullah Gülen',
    theme: 'Faith & Illumination',
  },
  {
    text: 'Service to humanity, when done sincerely for Allah’s sake, is one of the greatest forms of worship.',
    source: 'M. Fethullah Gülen',
    theme: 'Service & Sincerity',
  },
  {
    text: 'Patience is not merely to endure difficulties; it is to remain steadfast with grace until the light appears.',
    source: 'M. Fethullah Gülen',
    theme: 'Patience & Steadfastness',
  },
  {
    text: 'Hearts find peace only when they beat with love for Allah and compassion for His creation.',
    source: 'M. Fethullah Gülen',
    theme: 'Love & Compassion',
  },

  // 💫 Mevlana Rumi (Divan-e Shams-e Tabrizi & Mathnawi)
  {
    text: 'Your task is not to seek for love, but merely to seek and find all the barriers within yourself that you have built against it.',
    source: 'Mevlana Rumi',
    theme: 'Self-Discovery & Love',
  },
  {
    text: 'Raise your words, not your voice. It is rain that grows flowers, not thunder.',
    source: 'Mevlana Rumi',
    theme: 'Wisdom & Etiquette',
  },
  {
    text: 'Love is the bridge between you and everything.',
    source: 'Mevlana Rumi',
    theme: 'Love & Connection',
  },
  {
    text: 'The wound is the place where the light enters you.',
    source: 'Mevlana Rumi',
    theme: 'Healing & Hope',
  },
];

export default QUOTES;
